import { gql } from '@apollo/client';

export const PRICE_PREDICTION = gql`
  query getPricePrediction(
    $eurotaxCodes: [String!]
    $vehicleKM: Int
    $regionList: [String!]
    $provinceList: [String!]
    $vendorType: VendorType
    $areListingsFromVendorExcluded: Boolean
    $vehicleRegistrationDateISO8601: String
    $vehicleOptionals: [String!]
    $withPriceTrend: Boolean!
    $country: Country!
  ) {
    getPricePrediction(
      eurotaxCodes: $eurotaxCodes
      vehicleKM: $vehicleKM
      regionList: $regionList
      provinceList: $provinceList
      vendorType: $vendorType
      areListingsFromVendorExcluded: $areListingsFromVendorExcluded
      vehicleRegistrationDateISO8601: $vehicleRegistrationDateISO8601
      vehicleOptionals: $vehicleOptionals
      country: $country
    ) {
      success
      errorCode
      predictedPrice
      lowerboundPredictedPrice
      upperboundPredictedPrice
      averageListingDurationInDays
      detectedVehicleModelVersions
      vehicleKM
      vehicleRegistrationDateISO8601
      mds
      appealIndexValue
      appealIndexLabel
      priceTrend @include(if: $withPriceTrend) {
        predictedPrice
        dateISO8601
      }
    }
  }
`;
